module.exports = __webpack_public_path__ + "static/img/img-educator-feature-1.df8b47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-1.png
// module id = dSMx
// module chunks = 18